export default __webpack_public_path__ + "static/media/QRIS_Logo.68be1b5a.svg";